import React from 'react';
import { Redirect } from 'react-router-dom';
import { useCanViewProtocol } from './useCanViewProtocol';


export const ProtocolAccess = ({ children, prtInfo }) => {
  const canView = useCanViewProtocol(prtInfo?.leadGrp);

  if (canView) {
    return( 
      <div data-lead-grp={prtInfo?.leadGrp} data-canview={canView}>
        {children}
      </div>
    );
  }
  
  return <Redirect to="/noaccess" replace />;
};






